import {ILogService, IScope} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import IInjectorService = angular.auto.IInjectorService;
import _ from "lodash";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('ExceptionHandler');

/**
 * Overstyrer angulars standard ExceptionHandler som kun logger til $log.
 * Broadcaster en ExceptionHandler.exceptionEvent på rootScope.
 * Tjenesten må registreres under navnet "$exceptionHandler" for å overstyre angulars default handler.
 */
export class ExceptionHandler {
    static exceptionEvent = "ExceptionHandler:exception";

    static forInjiseringSomFactory() {
        return [
            regNavn.ng.$log,
            regNavn.ng.$injector,
            ($log: ILogService, $injector: IInjectorService) => {
                var handler = new ExceptionHandler($log, $injector);
                return (exception, cause) => handler.håndterException(exception, cause);
            }
        ]
    }

    constructor(private $log: ILogService, private $injector: IInjectorService) {
    }

    //offentlige metoder

    håndterException(exception, cause) {
        if (this.skalExceptionLogges(exception))
            //@ts-ignore
            this.$log.error.apply(this.$log, arguments); //som angulars exceptionhandler

        var $rootScope = (<IScope>this.$injector.get(regNavn.ng.$rootScope));
        $rootScope.$broadcast(ExceptionHandler.exceptionEvent, exception, cause);
    }

    private skalExceptionLogges(exception){
        if (!_.isString(exception)) return true;

        if (_.startsWith(exception, 'Possibly unhandled rejection: ')){
            debug('ignorerer exception pga manglende .catch() i promise', exception)
            return false;
        }

        return true;
    }
}
